module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/d8597945f33edaef1ea3506fcec71e3d.png";